import type { Components, Theme } from "@mui/material";

export const formControlLabelTheme: Components<Theme>["MuiFormControlLabel"] = {
  styleOverrides: {
    label: ({ theme }) => ({
      fontSize: theme.typography.body2.fontSize,
    }),
  },
};
